
export const QUESTIONS = [
  {
    id: 1,
    dimension: 'social',
    text: '朋友聚会后，我还能主动约下一场，而非只想回家躺平。（外向型）',
    options: [
      { label: 'A. 必须约！聚会结束才是快乐开始，回家躺平太无聊', value: 5 },
      { label: 'B. 看心情，聊得开心就约，不开心就溜', value: 4 },
      { label: 'C. 不确定，随缘吧，别人约就去，自己不主动', value: 3 },
      { label: 'D. 勉强能约，但心里已经想回家躺平了', value: 2 },
      { label: 'E. 绝不可能！聚会结束只想立刻回家，谁约都不去', value: 1 },
    ]
  },
  {
    id: 2,
    dimension: 'social',
    text: '陌生人搭话，我能顺势聊下去，不觉得尴尬。（外向型）',
    options: [
      { label: 'A. 太能了！陌生人搭话，我能聊到他想走', value: 5 },
      { label: 'B. 可以聊几句，不尴尬，主打一个礼貌回应', value: 4 },
      { label: 'C. 看话题，聊得来就聊，聊不来就沉默', value: 3 },
      { label: 'D. 勉强应付，全程尴尬到抠脚，只想结束对话', value: 2 },
      { label: 'E. 直接无视！陌生人搭话，我只想赶紧躲开', value: 1 },
    ]
  },
  {
    id: 3,
    dimension: 'social',
    text: 'emo时，我会找别人吐槽，而非自己默默消化。（外向型）',
    options: [
      { label: 'A. 必须吐槽！emo不吐槽，会憋出内伤', value: 5 },
      { label: 'B. 会找最亲近的人吐槽，不想一个人扛着', value: 4 },
      { label: 'C. 偶尔吐槽，有时候也会自己默默消化', value: 3 },
      { label: 'D. 很少吐槽，实在憋不住才会说一句', value: 2 },
      { label: 'E. 从不吐槽！emo就自己扛，不想麻烦别人', value: 1 },
    ]
  },
  {
    id: 4,
    dimension: 'social',
    text: '人群中，我愿意主动发言刷存在感，不喜欢当透明人。（外向型）',
    options: [
      { label: 'A. 必须刷！人群中不发言，等于白来', value: 5 },
      { label: 'B. 会主动发言，不想一直当透明人', value: 4 },
      { label: 'C. 看情况，有想法就说，没想法就沉默', value: 3 },
      { label: 'D. 偶尔发言，还是会有点不好意思', value: 2 },
      { label: 'E. 绝不发言！当透明人最舒服，不想被关注', value: 1 },
    ]
  },
  {
    id: 5,
    dimension: 'mental',
    text: '我容易情绪上头，时不时想“发疯”释放自己。（疯批型）',
    options: [
      { label: 'A. 太对了！情绪一上来就想发疯，主打一个随心所欲', value: 5 },
      { label: 'B. 经常情绪上头，偶尔会发疯释放', value: 4 },
      { label: 'C. 有时候会情绪上头，看情况发疯', value: 3 },
      { label: 'D. 很少情绪上头，偶尔会有发疯的念头', value: 2 },
      { label: 'E. 从不情绪上头，更不会发疯，主打一个冷静', value: 1 },
    ]
  },
  {
    id: 6,
    dimension: 'mental',
    text: '做决定全凭心情，不想被规矩束缚。（疯批型）',
    options: [
      { label: 'A. 全凭心情！规矩是什么，能吃吗', value: 5 },
      { label: 'B. 大多时候凭心情，偶尔会考虑规矩', value: 4 },
      { label: 'C. 一半一半，心情和规矩都考虑', value: 3 },
      { label: 'D. 很少凭心情，还是会遵守规矩', value: 2 },
      { label: 'E. 从不凭心情，做决定全看规矩和理性', value: 1 },
    ]
  },
  {
    id: 7,
    dimension: 'mental',
    text: '我经常脑补各种剧情，精神状态时好时坏。（疯批型）',
    options: [
      { label: 'A. 天天脑补！脑子里全是大戏，精神状态忽上忽下', value: 5 },
      { label: 'B. 经常脑补，有时候会陷入自己的剧情里', value: 4 },
      { label: 'C. 偶尔脑补，不会太投入', value: 3 },
      { label: 'D. 很少脑补，只有没事干的时候才会想一点', value: 2 },
      { label: 'E. 从不脑补！现实都忙不过来，哪有空想别的', value: 1 },
    ]
  },
  {
    id: 8,
    dimension: 'mental',
    text: '遇到不顺心，我会直接摆脸，藏不住情绪。（疯批型）',
    options: [
      { label: 'A. 必须摆脸！不顺心就写在脸上，藏都不藏', value: 5 },
      { label: 'B. 会摆脸，情绪藏不住，忍不住表现出来', value: 4 },
      { label: 'C. 偶尔摆脸，实在忍不住才会表现出来', value: 3 },
      { label: 'D. 很少摆脸，会勉强掩饰自己的情绪', value: 2 },
      { label: 'E. 从不摆脸！再不顺心也会掩饰，不把情绪挂在脸上', value: 1 },
    ]
  },
  {
    id: 9,
    dimension: 'emotional',
    text: '朋友难过时，我先共情安慰，而非理性分析。（共情型）',
    options: [
      { label: 'A. 必须共情！先安慰再说话，理性分析太冷漠', value: 5 },
      { label: 'B. 会先共情安慰，偶尔会理性分析', value: 4 },
      { label: 'C. 一半共情，一半理性，看朋友需求', value: 3 },
      { label: 'D. 会理性分析，偶尔会共情安慰', value: 2 },
      { label: 'E. 只理性分析！共情没用，解决问题才重要', value: 1 },
    ]
  },
  {
    id: 10,
    dimension: 'emotional',
    text: '我容易内耗，一件小事能纠结半天。（共情型）',
    options: [
      { label: 'A. 太内耗了！一件小事能纠结到深夜，翻来覆去想', value: 5 },
      { label: 'B. 经常内耗，小事也会纠结很久', value: 4 },
      { label: 'C. 偶尔内耗，纠结一会儿就放下了', value: 3 },
      { label: 'D. 很少内耗，只有大事才会稍微纠结', value: 2 },
      { label: 'E. 从不内耗！想清楚就做，纠结太浪费时间', value: 1 },
    ]
  },
  {
    id: 11,
    dimension: 'emotional',
    text: '我见不得别人委屈，总想伸手帮忙。（共情型）',
    options: [
      { label: 'A. 见不得！别人一委屈，我就想帮，哪怕自己吃亏', value: 5 },
      { label: 'B. 见不得别人委屈，会主动伸手帮忙', value: 4 },
      { label: 'C. 看情况，能帮就帮，帮不了就安慰', value: 3 },
      { label: 'D. 偶尔会帮，太麻烦的就不帮了', value: 2 },
      { label: 'E. 无所谓！别人委屈是别人的事，和我没关系', value: 1 },
    ]
  },
  {
    id: 12,
    dimension: 'emotional',
    text: '被反驳时，我会难过emo，而非冷静对线。（共情型）',
    options: [
      { label: 'A. 会emo！被反驳就忍不住难过，半天缓不过来', value: 5 },
      { label: 'B. 会难过，偶尔会emo，不想对线', value: 4 },
      { label: 'C. 有点难过，但不会emo，也不会主动对线', value: 3 },
      { label: 'D. 不怎么难过，会勉强冷静对线', value: 2 },
      { label: 'E. 从不难过！被反驳就冷静对线，主打一个不服输', value: 1 },
    ]
  },
  {
    id: 13,
    dimension: 'life',
    text: '我做事积极主动，不拖延、不摆烂。（内卷型）',
    options: [
      { label: 'A. 超积极！做事从不拖延，摆烂不存在的', value: 5 },
      { label: 'B. 比较积极，很少拖延，偶尔摆烂', value: 4 },
      { label: 'C. 一般般，不主动也不拖延，随缘做事', value: 3 },
      { label: 'D. 不太积极，偶尔拖延，经常摆烂', value: 2 },
      { label: 'E. 从不积极！拖延到最后，摆烂到极致', value: 1 },
    ]
  },
  {
    id: 14,
    dimension: 'life',
    text: '我喜欢争强好胜，不想输给别人。（内卷型）',
    options: [
      { label: 'A. 必须赢！争强好胜，绝不能输给别人', value: 5 },
      { label: 'B. 喜欢争强好胜，不想落后于人', value: 4 },
      { label: 'C. 偶尔争强好胜，大多时候随缘', value: 3 },
      { label: 'D. 不怎么争强好胜，输了也无所谓', value: 2 },
      { label: 'E. 从不争强好胜！输赢无所谓，摆烂最舒服', value: 1 },
    ]
  },
  {
    id: 15,
    dimension: 'life',
    text: '收到任务，我会立刻动手，不拖到最后。（内卷型）',
    options: [
      { label: 'A. 立刻动手！收到任务绝不拖延，主打一个高效', value: 5 },
      { label: 'B. 会尽快动手，不拖到最后一刻', value: 4 },
      { label: 'C. 过一会儿再动手，不着急也不拖延', value: 3 },
      { label: 'D. 经常拖到最后一刻，实在没办法才动手', value: 2 },
      { label: 'E. 拖到截止日期，能敷衍就敷衍，实在不行就放弃', value: 1 },
    ]
  },
  {
    id: 16,
    dimension: 'life',
    text: '我愿意为了目标付出努力，不敷衍、不摆烂。（内卷型）',
    options: [
      { label: 'A. 愿意！为了目标拼尽全力，绝不敷衍摆烂', value: 5 },
      { label: 'B. 愿意付出努力，偶尔会敷衍，但不摆烂', value: 4 },
      { label: 'C. 愿意付出一点努力，不敷衍也不内卷', value: 3 },
      { label: 'D. 不太愿意付出，经常敷衍，偶尔摆烂', value: 2 },
      { label: 'E. 不愿意！敷衍到底，摆烂至上，目标是什么不重要', value: 1 },
    ]
  },
];

export const RESULTS = {
  'ECFP': {
    title: '熹贵妃',
    desc: '贴合“矫情发疯、摆烂刷存在感”人设，甄嬛传熹贵妃经典发疯表情包',
    emoji: '👑',
    tags: ['矫情王者', '发疯先行者', '摆烂刷脸']
  },
  'ECFJ': {
    title: '安陵容',
    desc: '贴合“表面柔弱、背地里内卷”人设，“宝娟我的嗓子”名场面',
    emoji: '🧵',
    tags: ['阴暗爬行', '内卷达人', '嗓子没了']
  },
  'ECTP': {
    title: '项羽',
    desc: '贴合“狂傲疯批、摆烂装大佬”人设，霸气叉腰搞怪',
    emoji: '⚔️',
    tags: ['力拔山兮', '狂傲疯批', '大佬级摆烂']
  },
  'ECTJ': {
    title: '美国总统候选人',
    desc: '贴合“嘴炮拉满、自我感动式内卷”人设，搞怪竞选人',
    emoji: '🎤',
    tags: ['嘴炮王者', '自我感动', '演说家']
  },
  'EBFP': {
    title: '女权表演艺术家',
    desc: '贴合“表演型维权、共情摆烂”人设，搞怪吐槽',
    emoji: '🎭',
    tags: ['表演人格', '吐槽星人', '佛系正义']
  },
  'EBFJ': {
    title: '懂王',
    desc: '贴合“啥都懂、自我封神”人设，“我全都懂”自信抬杠',
    emoji: '👌',
    tags: ['懂王本王', '自信抬头', '逻辑鬼才']
  },
  'EBTP': {
    title: '黑熊精',
    desc: '贴合“咋咋呼呼、佛系摆烂”人设，西游记黑熊精搞怪',
    emoji: '🐻',
    tags: ['咋咋呼呼', '佛系黑熊', '憨憨摆烂']
  },
  'EBTJ': {
    title: '恶霸',
    desc: '贴合“外向冷漠、佛系内卷”人设，街头恶霸',
    emoji: '👹',
    tags: ['街头霸王', '冷漠卷王', '硬核佛系']
  },
  'ICFP': {
    title: '舔狗',
    desc: '贴合“摆烂式讨好、爱得卑微”人设，卑微讨好类搞怪',
    emoji: '🐶',
    tags: ['卑微第一名', '舔到最后', '纯情大冤种']
  },
  'ICFJ': {
    title: '圣母',
    desc: '贴合“无底线善良、过度内卷”人设，过度付出自嘲',
    emoji: '🙏',
    tags: ['大爱无疆', '圣母光环', '自我感动']
  },
  'ICTP': {
    title: '刀盾',
    desc: '贴合“坚硬冷漠、疯批摆烂”人设，坚硬冷漠拒绝妥协',
    emoji: '🛡️',
    tags: ['人间盾牌', '冷漠到底', '精神孤岛']
  },
  'ICTJ': {
    title: 'NPD',
    desc: '贴合“自我中心、冷漠内卷”人设，自恋狂魔',
    emoji: '🧛',
    tags: ['极度自恋', '冷漠精英', '掌控欲']
  },
  'IBFP': {
    title: 'NPD的血包',
    desc: '贴合“习惯性讨好、过度内耗”人设，卑微内耗类',
    emoji: '💉',
    tags: ['内耗黑洞', '能量容器', '惯性讨好']
  },
  'IBFJ': {
    title: '王一博老婆',
    desc: '贴合“默默守护、佛系内卷”人设，深情应援类',
    emoji: '💚',
    tags: ['精神股东', '默默应援', '佛系追星']
  },
  'IBTP': {
    title: '爸爸',
    desc: '贴合“话少嘴硬、爹系摆烂”人设，爹系嘴硬',
    emoji: '🚬',
    tags: ['沉默父亲', '嘴硬到底', '稳如老狗']
  },
  'IBTJ': {
    title: '快乐小狗贝',
    desc: '贴合“看似高冷、实则软萌”人设，可爱小狗软萌',
    emoji: '🐩',
    tags: ['表面高冷', '内在软萌', '反差萌']
  },
  'SPECIAL_FOOTBALL': {
    title: '中国男足',
    desc: '拥有“无论对手是谁，都能稳定发挥（指输球）”的神奇魔力。主打一个心理素质极强，挨再多骂也能心安理得吃海参。',
    emoji: '⚽️',
    tags: ['海参代言人', '稳定发挥', '留给对手的时间不多了', '让14亿人破防']
  },
};
